import { useUserOrganization } from '@modules-deprecated/app/organization'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

export const useIsBasicPlan = () => {
  const { organization, isLoading } = useUserOrganization()

  return {
    isBasicPlan: isLoading || !organization ? undefined : organization.subscriptionPlan === SubscriptionPlan.Basic,
    isLoading,
  }
}
